import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { PartnerListPageContext, PartnerListPageInitialState } from ".";

export const PartnerListPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(PartnerListPageInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <PartnerListPageContext.Provider value={context}>
      {children}
    </PartnerListPageContext.Provider>
  );
};
